import { Card, Col, ListGroup, Row } from "react-bootstrap";
import axios from "axios";
import vs from '../../images/profile/payment.png';
import {Link} from 'react-router-dom';
//lg
import { useTranslation, initReactI18next } from 'react-i18next';
import i18n from 'i18next';

const Footer = () => {
  const { t } = useTranslation();
  var d = new Date();
  return (
    <div className="footer m-4 text-black">
    <footer className=" text-light py-4">
      <div className="container">
        <div className="row">
          {/* Contact Information */}
          <div className="col-md-4 mb-3">
            <h5>Contact Us</h5>
            <p><strong>Phone:</strong> +1 234 567 890</p>
            <p><strong>Email:</strong> info@bulltraderbd.com</p>
            <p><strong>Address:</strong>  Block-H, Pragrati Sharani Road, Baridhara, Dhaka-1212</p>
          </div>

          {/* Quick Links */}
          <div className="col-md-4 mb-3">
            <h5>Quick Links</h5>
            <ul className="list-unstyled">
              <li><a href="https://bulltraderbd.com/" className="text-light">About Us</a></li>
              <li><a href="https://bulltraderbd.com/" className="text-light">Services</a></li>
              <li><a href="https://bulltraderbd.com/" className="text-light">Contact</a></li>
            </ul>
          </div>

          {/* Social Media */}
          <div className="col-md-4 mb-3">
            <h5>Follow Us</h5>
            <a href="https://facebook.com" className="text-light me-3"><i className="bi bi-facebook"></i> Facebook</a><br />
            <a href="https://twitter.com" className="text-light me-3"><i className="bi bi-twitter"></i> Twitter</a><br />
            <a href="https://instagram.com" className="text-light"><i className="bi bi-instagram"></i> Instagram</a>
          </div>
        </div>

        <hr className="bg-light" />
        <div className="text-center">
          <p className="mb-0">&copy; {new Date().getFullYear()} Your Company. All rights reserved.</p>
        </div>
      </div>
    </footer>
    </div>
  );
};

export default Footer;
